import {
  Component,
  OnInit,
  OnDestroy,
  Input,
  ChangeDetectorRef,
  Inject,
  ViewChild,
  ChangeDetectionStrategy
} from '@angular/core';

import { Store } from '@ngrx/store';
import { Subject, distinctUntilChanged, takeUntil, tap } from 'rxjs';
import { MapInfoWindow } from "@angular/google-maps";
import * as fromStore from '@app/claims/store';
import * as fromCoreStore from '@app/core/store';
import { CloseModal } from '@app/modals/store/actions/layout.actions';
import { GetCoordinatesService } from '@app/tracking/container/tracking/GetCoordinatesService.service'
import * as fromClaimStore from '@app/claims/store'
import { ThemeService } from '@app/shared/services'

/* Dark map styling — same palette the other JS-API maps use. */
const DARK_MAP_STYLES: google.maps.MapTypeStyle[] = [
  { elementType: 'geometry', stylers: [{ color: '#212121' }] },
  { elementType: 'labels.text.fill', stylers: [{ color: '#757575' }] },
  { elementType: 'labels.text.stroke', stylers: [{ color: '#212121' }] },
  { featureType: 'administrative', elementType: 'geometry', stylers: [{ color: '#757575' }] },
  { featureType: 'administrative.country', elementType: 'labels.text.fill', stylers: [{ color: '#9e9e9e' }] },
  { featureType: 'administrative.locality', elementType: 'labels.text.fill', stylers: [{ color: '#bdbdbd' }] },
  { featureType: 'poi', elementType: 'labels.text.fill', stylers: [{ color: '#757575' }] },
  { featureType: 'poi.park', elementType: 'geometry', stylers: [{ color: '#181818' }] },
  { featureType: 'poi.park', elementType: 'labels.text.fill', stylers: [{ color: '#616161' }] },
  { featureType: 'road', elementType: 'geometry.fill', stylers: [{ color: '#2c2c2c' }] },
  { featureType: 'road', elementType: 'labels.text.fill', stylers: [{ color: '#8a8a8a' }] },
  { featureType: 'road.arterial', elementType: 'geometry', stylers: [{ color: '#373737' }] },
  { featureType: 'road.highway', elementType: 'geometry', stylers: [{ color: '#3c3c3c' }] },
  { featureType: 'road.highway.controlled_access', elementType: 'geometry', stylers: [{ color: '#4e4e4e' }] },
  { featureType: 'road.local', elementType: 'labels.text.fill', stylers: [{ color: '#616161' }] },
  { featureType: 'transit', elementType: 'labels.text.fill', stylers: [{ color: '#757575' }] },
  { featureType: 'water', elementType: 'geometry', stylers: [{ color: '#000000' }] },
  { featureType: 'water', elementType: 'labels.text.fill', stylers: [{ color: '#3d3d3d' }] },
]

@Component({
    selector: 'app-claim-shops-nearby',
    templateUrl: './claim-shops-nearby.component.html',
    styleUrls: ['claim-shops-nearby.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})

export class ClaimShopsNearby implements OnInit, OnDestroy {
    @ViewChild('map') mapElement
    @ViewChild(MapInfoWindow, { static: false }) info;

    destroyed$ = new Subject<boolean>();
    map;
    @Input()
    set props (v) {
      if (v) {
        this._props = v
        let location = null
        if (v?.location?.lat == null && v?.location?.lng == null) {
          location = this.center
        } else {
          location = v?.location
        }

        this.location = location
        this.vehicleLocation = location
      }
    }

    _props
    filters
    shop
    currentAccount
    selectedCompany
    accounts
    type
    geocoder
    coordinates
    location
    vehicleLocation
    center = { lat: 37.0958131, lng: -95.7127144 }

    infoWindowOptions: google.maps.InfoWindowOptions = {
      pixelOffset: new google.maps.Size(0, -30)
    };

    mapOptions: google.maps.MapOptions = {}
    private darkModeObserver: MutationObserver

    constructor(
      private store: Store<fromStore.State>,
      private coreStore: Store<fromCoreStore.State>,
      private cdr: ChangeDetectorRef,
      private themeService: ThemeService,
      @Inject(GetCoordinatesService) private getCoordinatesService: GetCoordinatesService
    ) {}

    /* The <google-map> is JS-API, so apply a real dark StyledMapType via options.styles
       (same as tracking-map), switching when the .dark class toggles. */
    private applyMapTheme(detectChanges = false) {
      this.mapOptions = {
        ...this.mapOptions,
        styles: this.themeService.isDark ? DARK_MAP_STYLES : []
      }
      if (detectChanges) this.cdr.detectChanges()
    }

    ngOnInit() {
      this.applyMapTheme()
      this.darkModeObserver = new MutationObserver(() => this.applyMapTheme(true))
      this.darkModeObserver.observe(document.documentElement, { attributeFilter: ['class'] })
      this.getCoordinatesService.getLatLng$.subscribe(() => this.eventMapListener());
      this.geocoder = new google.maps.Geocoder();
      this.store.select(fromClaimStore.selectClaimShops).pipe(
        takeUntil(this.destroyed$),
        tap((accounts: any) => {
          if (accounts) {

            let i = 1;
            for (let account of accounts) {
              account.num = i++;
              let fullAddress = ''
              for (const [key, value] of Object.entries(account.address)) {
                if (key != '_id' && key != 'addressLine2' && value != ''){
                  fullAddress += `${value} `;
                }
              }
              account.fullAddress = fullAddress
            }

            console.log({accounts})

            this.accounts = accounts.filter(l => l?.location && l?.type == 'TRUCK SHOP' || l?.type == 'AUTO SHOP');
            this.cdr.detectChanges();
          }
        })
      ).subscribe();

      this.store.select(fromCoreStore.selectCoreValContacts).pipe(
        takeUntil(this.destroyed$),
        tap((statuses) => {
          if (statuses) {
            this.type = statuses.types.filter(l => l?.isCompany && (l?.name == 'TRUCK SHOP' || l?.name == 'AUTO SHOP'));
            this.cdr.detectChanges();
          }
        })
      ).subscribe();
    }

    getShops () {
      if (!this.filters?.type || !this.filters?.type.length) {
        this.filters = {
          type: ['TRUCK SHOP', 'AUTO SHOP']
        }
      }
      let filters = {
        ...this.filters,
        coordinates: JSON.stringify(this.coordinates),
      }
      filters = Object.fromEntries(
        Object.entries(filters).filter(([key, value]) => value !== '')
      );
      this.store.dispatch(new fromClaimStore.GetShops({ filters }))
    }

    setFilter(name, val) {
      if (name == 'type' && (JSON.stringify(this.filters?.type.sort()) === JSON.stringify(val.sort()))) return
      this.filters[name] = val
      this.getShops()
    }

    eventMapListener() {
      let map = this.mapElement.googleMap
        let bounds = map.getBounds();
        let sw = bounds.getSouthWest();
        let ne = bounds.getNorthEast();
        
        let left = sw.lng();
        let down = sw.lat();
        let right = ne.lng();
        let up = ne.lat();
  
        this.coordinates = {
          'lng1': left, 'lat1': down, 'lng2': right, 'lat2': up
        }

        this.getShops()
    }

    openAccountInfo(account, marker?){
      this.selectedCompany = account
      this.info.open(marker)
    }

    setPosition(loc) {
      this.location = loc
    }

    trackByFunc(index, item){
      return index;
    }

    closeClick() {
      this.currentAccount = null
      this.selectedCompany = null
    }

    onMapReady(){
      if(this.map)return
      this.map = this.mapElement.googleMap
      this.eventMapListener()
    }

    close() {
      this.coreStore.dispatch(new CloseModal());
    }

    ngOnDestroy() {
      this.store.dispatch(new fromClaimStore.GetShopsSuccess([]))
      this.destroyed$.next(true);
      this.destroyed$.complete();
      this.darkModeObserver?.disconnect();
    }
}